import React from 'react';

import crown from '../../common/svg/movie-voting/crown_icon.svg';
import { VotingRoundState } from '../../hooks/voting.hooks';
import { NotificationCard } from '../movie-voting/NotificationCard.component';
import type {
  AdditionalInfoProps,
  DetailsProps,
} from './card/AdditionalInfo.component';
import { AdditionalInfo, Details } from './card/AdditionalInfo.component';
import type { VotingCardProps } from './card/VotingCard.component';
import { VotingCard } from './card/VotingCard.component';
import styles from './Project.module.css';

export interface Props
  extends VotingCardProps,
    DetailsProps,
    AdditionalInfoProps {
  name: string;
  studio: string;
  image: string;
  votingState: VotingRoundState;
  isWinner: boolean;
  hasBeenFinanced: boolean;
}

interface FullProps extends Props {
  trailerLink: string;
}

export const Project: React.FC<FullProps> = props => {
  const {
    trailerLink,
    budget,
    name,
    studio,
    image,
    description,
    cast,
    additionalDetails,
    isWinner,
    hasBeenFinanced,
    ...movieVotingProps
  } = props;
  const movieDetailsProps = { description, cast };
  const movieInfoProps = { budget, additionalDetails };

  return (
    <div className="flex flex-col items-center w-4/5">
      <div className="max-w-screen-lg">
        {movieVotingProps.votingState === VotingRoundState.Canceled && (
          <NotificationCard
            title="Voting Cancelled"
            body="Voting was cancelled, you may still collect your deposited STARS and STARS rewards at the end of the voting period."
          />
        )}
        {movieVotingProps.votingState === VotingRoundState.Paused && (
          <NotificationCard
            title="Voting paused"
            body="Voting and unvoting has been temporarily disabled. Contact mogul support if you have immediate issues."
          />
        )}
        {movieVotingProps.endBlock.number <=
          movieVotingProps.currentBlock.number &&
          (hasBeenFinanced ? (
            <NotificationCard
              image={crown}
              imageClassName="p-1 mr-2 h-8 rounded-full bg-yellow-300"
              title="Project Financed"
              body={`${name} has been financed through Mogul.`}
            />
          ) : (
            isWinner && (
              <NotificationCard
                image={crown}
                imageClassName="p-1 mr-2 h-8 rounded-full bg-yellow-300"
                title="wINNER!"
                body={`${name} has won their round.`}
              />
            )
          ))}
        <div className="fontVanguard font-bold xl:text-7xl md:text-6xl text-4xl mt-8">
          {name}
        </div>
        <div className="text-secondary mt-3">{studio}</div>

        <div className="flex mt-8 mb-10 flex-wrap xl:flex-nowrap justify-center">
          <img
            className={styles.poster + ' xl:mr-8 rounded'}
            alt="movie poster"
            src={image}
          />

          <div className={styles.form + ' w-full mt-8 xl:mt-0'}>
            <VotingCard {...movieVotingProps} />
          </div>
        </div>

        {trailerLink && (
          <div
            className={
              styles.iframeContainer + ' relative overflow-hidden w-full'
            }
          >
            <iframe
              className="absolute inset-0 w-full h-full"
              title="Trailer Link"
              src={trailerLink}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        <Details {...movieDetailsProps} />
        <AdditionalInfo {...movieInfoProps} />
      </div>
    </div>
  );
};
